/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const FieldImageSetIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="FieldImageSetIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              d="M7 6C7.55228 6 8 5.55228 8 5C8 4.44772 7.55228 4 7 4C6.44772 4 6 4.44772 6 5C6 5.55228 6.44772 6 7 6Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5 2C4.44772 2 4 2.44772 4 3V11C4 11.5523 4.44772 12 5 12H13C13.5523 12 14 11.5523 14 11V3C14 2.44771 13.5523 2 13 2H5ZM5 3L13 3V10.2929L9 6.29289L5 10.2929V3ZM9 7.70711L12.2929 11H5.70711L9 7.70711Z"
              fill="currentColor"
            />
            <path
              d="M3 13V4H2V13C2 13.5523 2.44771 14 3 14H12V13H3Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

FieldImageSetIcon.tags = ['image', 'gallery', 'photo', 'album', 'collection'];

FieldImageSetIcon.category = 'CMS Fields';

FieldImageSetIcon.iconSize = 16;
